import { createContext, type PropsWithChildren, useContext, useRef, useState } from 'react';

type LoaderContextProps = {
  loaderCount: number;
  registerLoader: (loader_uid: string) => () => void;
};

const LoaderContext = createContext<LoaderContextProps>({
  loaderCount: 0,
  registerLoader: () => () => undefined,
});

export const useLoaderContext = () => useContext(LoaderContext);

export const LoaderProvider = ({ children }: PropsWithChildren) => {
  const loaders = useRef<Set<string>>(new Set());
  const [loaderCount, setLoaderCount] = useState<number>(0);

  const registerLoader = (loader_uid: string) => {
    loaders.current.add(loader_uid);
    setLoaderCount(loaders.current.size);

    return () => {
      loaders.current.delete(loader_uid);
      setLoaderCount(loaders.current.size);
    };
  };

  return <LoaderContext.Provider value={{ registerLoader, loaderCount }}>{children}</LoaderContext.Provider>;
};
